import React from 'react'

const AgeChart = ({ data }) => {
  // Define your age ranges
  const ageGroups = ['18-24', '25-34', '35-44', '45-54', '55-64', '65+']

  // Count age group frequencies
  const counts = ageGroups.reduce((acc, group) => {
    acc[group] = data.filter((d) => {
      const age = d.Age?.trim()
      return age === group
    }).length
    return acc
  }, {})

  const total = Object.values(counts).reduce((sum, count) => sum + count, 0)

  // Compute percentage
  const percentages = ageGroups.map((group) => ({
    label: group,
    value: total ? ((counts[group] / total) * 100).toFixed(0) : 0,
  }))

  return (
    <div className="bg-white rounded shadow p-4 w-full">
      <h2 className="font-semibold text-sm text-gray-700 mb-4">AGE</h2>
      <div className="space-y-4">
        {percentages.map(({ label, value }) => (
          <div key={label}>
            <div className="flex justify-between mb-1">
              <span className="text-sm text-gray-700">{label}</span>
              <span className="text-sm font-bold text-gray-900">{value}%</span>
            </div>
            <div className="w-full bg-gray-200 h-2 rounded">
              <div
                className="bg-sky-400 h-2 rounded"
                style={{ width: `${value}%` }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AgeChart
